
(() => {
    const initScreenHeight = () => {
        // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
        document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    }

    let timeout = false;
    window.addEventListener('resize', () => {
        clearTimeout(timeout);
        timeout = setTimeout(initScreenHeight, 250);
    })
    initScreenHeight();
})();

(() => {
    const header = document.querySelector('.section-header');

    window.addEventListener('scroll', () => {
        const top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

        if (top > 150) {
            header.classList.add('section-header--small');
        } else {
            header.classList.remove('section-header--small');
        }
    });
})();

(() => {
    document.querySelector('.section-header__navtoggle').addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        document.body.classList.remove('layout--search');
        document.body.classList.toggle('layout--overlay');

        const submenu = document.querySelectorAll('.section-header__navigation li.submenu--active');
        if (submenu) {
            submenu.forEach((el) => {
                el.classList.remove('submenu--active');
            })
        }
    });

    const navi = document.querySelector('.section-header__navigation');

    document.querySelectorAll('.section-header__navigation li.submenu').forEach((el) => {
        el.addEventListener('click', (e) => {
            if (window.innerWidth >= 1220 || window.innerWidth - e.clientX > 60) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            el.classList.add('submenu--active');
            navi.classList.add('submenu--active');
        });
    });

    document.querySelectorAll('.section-header__navigation a.back').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            el.parentNode.parentNode.classList.remove('submenu--active');
        })
    });
})();

(() => {
    if (document.querySelector('.section-header__searchtoggle')) {
        document.querySelector('.section-header__searchtoggle').addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (document.body.classList.contains('layout--search')) {
                closeOverlays();
            } else {
                closeOverlays();
                document.body.classList.add('layout--search');
                document.querySelector('.section-header__searchfield').focus();
            }
        });
    }

    if (document.querySelector('.section-header__search')) {
        document.querySelector('.section-header__search').addEventListener('click', (e) => {
            e.stopPropagation();
        })
    }

    const parent = document.querySelector('.section-header__search') || document.querySelector('.section-header__inside');

    let closeTimer;
    const closeOverlays = () => {
        document.body.classList.remove('layout--overlay');
        document.body.classList.remove('layout--search');

        document.querySelectorAll('.section-header__navigation li.open').forEach((el) => {
            el.classList.remove('open');
        });

        document.querySelectorAll('.section-header__navigation .submenu--active, .section-header__navlevel2 .submenu--active').forEach((el) => {
            el.classList.remove('submenu--active');
        });

        document.querySelectorAll('.section-header__navlevel2--active').forEach((el) => {
            el.addEventListener('transitionend', () => {
                el.style.display = 'none';
            }, { once: true });

            el.classList.remove('section-header__navlevel2--active');
        });
    };
    const autoClose = () => {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeOverlays, 300);
    }

    document.querySelectorAll('.section-header__navigation .level_1 > li > a').forEach((el) => {
        const dropdown = el.nextElementSibling;

        if (!dropdown || !dropdown.classList.contains('submenu')) {
            return;
        }

        let overlay;
        let withSubmenu = el.parentNode.classList.contains('with-submenu');

        el.addEventListener('click', (e) => {
            if (window.innerWidth < 1220) {
                return;
            }

            e.stopPropagation();
        });

        el.addEventListener('mouseenter', (e) => {
            if (window.innerWidth < 1220) {
                return;
            }

            clearTimeout(closeTimer);

            if (overlay && overlay.classList.contains('section-header__navlevel2--active')) {
                return;
            }

            closeOverlays();

            if (!overlay) {
                overlay = document.createElement('div');
                overlay.insertBefore(dropdown.cloneNode(true), null);
                overlay.classList.add('section-header__navlevel2');

                if (withSubmenu) {
                    overlay.classList.add('section-header__navlevel2--with-submenu');
                }

                parent.parentNode.insertBefore(overlay, parent);

                overlay.addEventListener('click', (e) => {
                    e.stopPropagation();
                });

                overlay.addEventListener('mouseenter', (e) => {
                    clearTimeout(closeTimer);
                });

                overlay.addEventListener('mouseleave', (e) => {
                    autoClose();
                });

                window.addEventListener('resize', () => {
                    if (window.innerWidth < 1220) {
                        parent.parentNode.removeChild(overlay);
                        overlay = undefined;
                    }
                })

                if (withSubmenu) {
                    overlay.querySelectorAll('.level_2 > li > a').forEach((el) => {
                        el.addEventListener('mouseenter', (e) => {
                            e.preventDefault();
                            e.stopPropagation();

                            const show = el.parentNode.classList.contains('submenu');

                            Array.from(el.parentNode.parentNode.children).forEach((el) => {
                                el.classList.remove('submenu--active');
                            })

                            if (show) {
                                el.parentNode.classList.add('submenu--active');
                            }
                        });
                    });
                }
            }

            overlay.style.display = 'block';

            setTimeout(() => {
                el.parentNode.classList.add('open');
                overlay.classList.add('section-header__navlevel2--active');
            }, 0);
        });

        el.addEventListener('mouseout', () => {
            if (window.innerWidth < 1220) {
                return;
            }

            autoClose();
        });
    });

    document.body.addEventListener('click', () => {
        if (window.innerWidth < 1220) {
            return;
        }

        closeOverlays();
    }, false);
})();
